import googleAuthenticatorApp from "../../../assets/images/google-authenticator-app.svg";
import appStore from "../../../assets/images/app-store.png";
import googlePlay from "../../../assets/images/google-play.png";

import { IconButton } from "../../../components";
import { Step1Wrapper, ButtonsWrapper } from "./styled";

const Step1 = () => {
  return (
    <Step1Wrapper>
      <img
        src={googleAuthenticatorApp}
        alt="google-authenticator-app"
        id="google-authenticator-app"
      />

      <ButtonsWrapper>
        <IconButton
          as="a"
          target={"blank"}
          href={
            "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
          }
        >
          <img src={googlePlay} alt={"google-play"} />
        </IconButton>

        <IconButton
          as="a"
          target={"blank"}
          href={"https://apps.apple.com/app/google-authenticator/id388497605"}
        >
          <img src={appStore} alt={"app-store"} />
        </IconButton>
      </ButtonsWrapper>
    </Step1Wrapper>
  );
};

export default Step1;
